__turbopack_context__.v({
  "deleted": "TeamProjectCard-module-scss-module__qtUfxq__deleted",
  "edit": "TeamProjectCard-module-scss-module__qtUfxq__edit",
  "maintainerBadge": "TeamProjectCard-module-scss-module__qtUfxq__maintainerBadge",
  "name": "TeamProjectCard-module-scss-module__qtUfxq__name",
  "nameAndFunds": "TeamProjectCard-module-scss-module__qtUfxq__nameAndFunds",
  "nameAndTagline": "TeamProjectCard-module-scss-module__qtUfxq__nameAndTagline",
  "profile": "TeamProjectCard-module-scss-module__qtUfxq__profile",
  "profileLogo": "TeamProjectCard-module-scss-module__qtUfxq__profileLogo",
  "raisingFundsWeb": "TeamProjectCard-module-scss-module__qtUfxq__raisingFundsWeb",
  "root": "TeamProjectCard-module-scss-module__qtUfxq__root",
  "tagline": "TeamProjectCard-module-scss-module__qtUfxq__tagline",
});
